import axios from 'axios'
import { store } from '@/store/store'
import config from '@/config'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}api/lon-category`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const lonCategoryApi = {
  getCategories(params) {
    return instance().get('', { params })
  },
  createCategory(data) {
    return instance().post('', data)
  },
  updateCategory(id, data) {
    return instance().patch(`${id}`, data)
  },
  deleteCategory(id, params) {
    return instance().delete(`${id}`, { params })
  }
}

export default lonCategoryApi



// WEBPACK FOOTER //
// ./src/api/lon-category.js